module.exports = __webpack_public_path__ + "img/reaction3.2bd474a6.png";